export const t = (value: string) => value;
